import { render, staticRenderFns } from "./FfgKey.vue?vue&type=template&id=68baa27f&"
import script from "./FfgKey.vue?vue&type=script&lang=js&"
export * from "./FfgKey.vue?vue&type=script&lang=js&"
import style0 from "./FfgKey.vue?vue&type=style&index=0&id=68baa27f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports